module.exports = __webpack_public_path__ + "static/media/5.7bb3bd52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/soligorsk/5.jpg
// module id = 544
// module chunks = 0